import { AxiosRequestConfig } from 'axios';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { ApiError, Identifier, WidgetTemplate, Widgets } from '@types';
import { config } from '../../config';

export const fetchWidgetAsync = createAsyncAction(
    [
        'widgets/FETCH_WIDGETS_REQUEST',
        (refresh: any = '?refresh=true') => {
            return {
                url: `${config.env('awsUrl')}/api/v1/selfserv/customers/widgets${refresh ? refresh : ''}`,
                method: 'get'
            } as AxiosRequestConfig;
        }
    ],
    ['widgets/FETCH_WIDGETS_SUCCESS', (response: Widgets) => response],
    ['widgets/FETCH_WIDGETS_FAILURE', (error: ApiError) => error],
    'widgets/FETCH_WIDGETS_CANCEL'
)();
export const fetchWidgetRefreshAsync = createAsyncAction(
    [
        'widgetsRefresh/FETCH_WIDGETS_REQUEST',
        (refresh?: any) => {
            return {
                url: `${config.env('awsUrl')}/api/v1/selfserv/customers/widgets${refresh ? refresh : ''}`,
                method: 'get'
            } as AxiosRequestConfig;
        }
    ],
    ['widgetsRefresh/FETCH_WIDGETS_SUCCESS', (response: Widgets) => response],
    ['widgetsRefresh/FETCH_WIDGETS_FAILURE', (error: ApiError) => error],
    'widgetsRefresh/FETCH_WIDGETS_CANCEL'
)();

export const updateWidgetOfferCards = createAction('UPDATE_WIDGET_OFFER_CARDS', (cards: WidgetTemplate[]) => cards)();
export const updateNbpCardsRefactor = createAction('UPDATE_NBP_CARD_REFACTOR', (payload: any) => payload)();

export const broadcastCashOutResponse = createAction('BROADCAST_CASHOUT_RESPONSE', (metadata: any) => metadata)();

export const setSelectedLoanNumber = createAction('SET_SELECTED_LOANNUMBER', (identifier: Identifier) => identifier)();
export const setOfferTypeSelected = createAction('SET_OFFER_TYPE_SELECTED', (type: string) => type)();
export const clearLoanNDStatus = createAction('CLEAR_LOAN_ND_STATUS', (clearedLoan: string) => clearedLoan)();
export const removeTileOffer = createAction('REMOVE_TILE_OFFER', (tileOffer: any) => tileOffer)();
export const updatePropertyValue = createAction('UPDATE_PROPERTY_VALUE', (data: any) => data)();
export const updatePropertyValueError = createAction('UPDATE_PROPERTY_VALUE_ERROR', (data: any) => data)();
export const removeHVtileChildProduct = createAction('REMOVE_HV_TILE_CHILD_PRODUCT', (tileOffer: any) => tileOffer)();
